/* eslint-disable */
import JobOrdersView from "./JobOrdersView"

const MyJobOrdersView = () => {
  return <JobOrdersView isMyJobsView />
}

export default MyJobOrdersView
